import api from '@/services/api'
import { API_ENDPOINTS } from '@myorg/type-lib'
import {  MenuItem } from '@myorg/menu-editor-lib'
import { logger } from '@myorg/type-lib';


// 實作 Lib 定義的介面
export const categoryApiImpl = {
  // no use
  assignItemsToCategory: async (payload: { categoryName: string, itemIds: string[] }) => {
    const res = await api().post(API_ENDPOINTS.MENU.CATEGORY_ASSIGN, payload)
    return res.data
  },
  // 取得清單
  fetchCategories: async () => {
    const res = await api().get(API_ENDPOINTS.MENU.CATEGORY)
    return res.data // 預期回傳 Array<CategoryData>
  },
  // 實作批量新增
  // Updated API Implementation
  createCategories: async (payload: { name: string, orderNum: number }[]) => {
      // 1. Corrected loop syntax: use => instead of ->
      payload.forEach(item => {
          logger.log("Creating category:", item.name, "with order:", item.orderNum);
      });

      // 2. Sending the payload to the backend
      // Usually, backends expect the array directly or wrapped in an object
      const res = await api().post(API_ENDPOINTS.MENU.CATEGORY, { 
        categories: payload 
      }); 
      
      return res.data;
  },

  // updateCategoryItems: async (categoryId: string, itemIds: string[]) => {
  //   // Use backticks `` and ${} to inject the ID into the path
  //     const res = await api().put(`/api/menu/category/${categoryId}/items`, { 
  //         itemIds: itemIds 
  //     });
  //     return res.data;
  // }

  // UPDATE: Change second parameter from itemIds: string[] to payload: any
  updateCategoryItems: async (categoryId: string, payload: { itemIds: string[] }) => {
      const res = await api().put(API_ENDPOINTS.MENU.CATEGORY_ITEMS(categoryId), payload);
      return res.data;
  }

  
  // createCategories: async (dataList: any[]) => {
  //   // 這裡根據您的後端 API，可以是一次發一個 Array
  //   // /api/menu/category/:id/items
  //   const res = await api().put('/api/menu/category/:id/items', { categories: dataList })
  //   return res.data // 預期回傳新增成功的 Array
  // }
}

// 模擬從資料庫或之前的 JSON 取得的資料
export const rawItems = [
  { "id": "8e339a5c-85df-435f-99a7-8b02e7b760e8", "name": "漢堡", "price": 103, "order": 1, "merchantId": "..." },
  // ... 其他資料
]

export const menuApi = {
  getMenu: async (): Promise<any[]> => {
    const merchantId = localStorage.getItem("merchantId");
    if (!merchantId) {
      throw new Error('Merchant ID not found in storage')
    }
    const res = await api().get(API_ENDPOINTS.MENU.BY_MERCHANT(merchantId))
      .then(r => r.data)
    return res
  },
  createMenuItems: async (items: Omit<MenuItem, 'id'>[]): Promise<MenuItem[]> => {
  // createMenuItems: (item: { name: string; price: number; order: number }) =>{
    return api().post(API_ENDPOINTS.MENU.BASE, items)
      .then(r => r.data)
  },
  // FIX: This function now returns the created MenuItem
  createMenuItem: async (item: Omit<MenuItem, 'id'>): Promise<MenuItem> => {
    const response = await fetch(API_ENDPOINTS.MENU.BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item),
    });

    if (!response.ok) throw new Error('Failed to create item');

    // This ensures the return type is Promise<MenuItem>
    const newItem: MenuItem = await response.json();
    return newItem; 
  },
}



// export const categoryRoute = {
//   path: '/admin/category-manager',
//   component: CategoryManagerPage,
//   props: {
//     categoryApi: categoryApiImpl,
//     merchantId: '8aaf84df-4d4f-436c-bd70-963a440f0448'
//   }
// }